__turbopack_context__.v({
  "className": "Fb10DG_className",
  "variable": "Fb10DG_variable",
});
